import { Modal } from "@mui/material";
import React, { useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import dummy1 from "../../../../assets/img/thumb_assemble@2x.jpg";
import dummy2 from "../../../../assets/img/thumb_breakingnews@2x.jpg";
import dummy3 from "../../../../assets/img/thumb_buildings@2x.jpg";
import dummy4 from "../../../../assets/img/thumb_data@2x.jpg";
import dummy5 from "../../../../assets/img/thumb_fiveperson@2x.jpg";
import dummy6 from "../../../../assets/img/thumb_interview@2x.jpg";
import dummy7 from "../../../../assets/img/thumb_leaf@2x.jpg";
import dummy8 from "../../../../assets/img/thumb_meetings@2x.jpg";
import dummy9 from "../../../../assets/img/thumb_mic@2x.jpg";
import dummy10 from "../../../../assets/img/thumb_mugcup@2x.jpg";
import displayImg1 from "../../../../assets/img/assemble.jpg";
import displayImg2 from "../../../../assets/img/breakingnews.jpg";
import displayImg3 from "../../../../assets/img/buildings.jpg";
import displayImg4 from "../../../../assets/img/data.jpg";
import displayImg5 from "../../../../assets/img/fiveperson.jpg";
import displayImg6 from "../../../../assets/img/interview.jpg";
import displayImg7 from "../../../../assets/img/leaf.jpg";
import displayImg8 from "../../../../assets/img/meetings.jpg";
import displayImg9 from "../../../../assets/img/mic.jpg";
import displayImg10 from "../../../../assets/img/mugcup.jpg";
import useCustomHook from "../../../reducers/ContentCreateHook";
import {LoadingSpinner} from '../../../components/Icons';

const PresetImagesDialog = ({ open, onClose, onConfirm, onConfirmPopupOpen }: any) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const dummyImages = [
    { name: "thumb_assemble@2x.jpg", src: dummy1, displaySrc: displayImg1 },
    { name: "thumb_breakingnews@2x.gif", src: dummy2, displaySrc: displayImg2 },
    { name: "thumb_buildings@2x.jpg", src: dummy3, displaySrc: displayImg3 },
    { name: "thumb_data@2x.jpg", src: dummy4, displaySrc: displayImg4 },
    { name: "thumb_fiveperson@2x.jpg", src: dummy5, displaySrc: displayImg5 },
    { name: "thumb_interview@2x.jpg", src: dummy6, displaySrc: displayImg6 },
    { name: "thumb_leaf@2x.jpg", src: dummy7, displaySrc: displayImg7 },
    { name: "thumb_meetings@2x.jpg", src: dummy8, displaySrc: displayImg8 },
    { name: "thumb_mic@2x.jpg", src: dummy9, displaySrc: displayImg9 },
    { name: "thumb_mugcup@2x.jpg", src: dummy10, displaySrc: displayImg10 },
  ];
  const {
    loadingNews,
  } = useCustomHook()

  return (
    <Modal open={open} onClose={onClose}>
      <div className="bg-white rounded-2xl p-6 w-[716px] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] outline-none overflow-y-auto max-h-">
        <h2 className="text-2xl font-bold alu-text-base-2 mb-2">
          プリセット画像の選択
        </h2>
        <p className="text-xs alu-text-base-2 mb-6">
          aloop が用意した画像をご利用いただけます。
        </p>
        <div className="mb-6 relative w-[100%] px-3 py-4 flex flex-wrap gap-[0.875rem] border alu-border rounded-lg bg-white">
          {dummyImages.map((image, index) => (
            <div
              onClick={() => setSelectedImage({index, image: image.displaySrc})}
              key={index}
              className={`${selectedImage?.index === index ? "outline outline-1 outline-[#FF861A]" : ""} w-[12.75rem] h-[7.125rem] relative alu-image-box-shadow`}
            >
              <img
                src={image.src}
                alt={`Preset ${index + 1}`}
                className={`w-full h-full object-cover cursor-pointer ${selectedImage?.index !== index ?  "hover:opacity-80" : ""}`}
              />
            </div>
          ))}
        </div>
        <div className="flex items-center justify-center gap-8">
          <CustomButton
              type="button"
              onClick={onClose}
              variant="text"
          >
              キャンセル
          </CustomButton>
          <CustomButton
            disabled={loadingNews || !selectedImage?.image}
            type="button"
            onClick={() => {onConfirm(selectedImage?.image); onClose();}}
            size="md"
          >
            <p>{loadingNews ? "送信中..." : "決定"}</p>
            {loadingNews && (
                <span><LoadingSpinner /></span>
            )}
          </CustomButton>
        </div>
      </div>
    </Modal>
  );
};

export default PresetImagesDialog;
